export const styles = {
  wrapper:
    'flex-1 bg-accentSecondary10 lg:bg-neutral20 min-h-full overflow-x-hidden lg:pl-[20rem]',
};
